import { render, staticRenderFns } from "./UserUserGroups.vue?vue&type=template&id=0769c7be&scoped=true&"
import script from "./UserUserGroups.vue?vue&type=script&lang=ts&"
export * from "./UserUserGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0769c7be",
  null
  
)

export default component.exports